const skillsData = [
  {
    id: 1,
    name: "JavaScript",
    description:
      "Maîtrisant le cœur interactif du web, je jongle avec JavaScript pour créer des expériences utilisateur dynamiques et des fonctionnalités modernes. Des animations fluides aux applications web interactives, je donne vie aux idées à travers le code.",
    icon: "./images/javascript.png",
  },
  {
    id: 2,
    name: "NodeJs",
    description:
      "Avec Node.js, je construis des applications côté serveur rapides et évolutives. Exploitant la puissance de JavaScript, je crée des services web réactifs et performants, offrant des expériences utilisateur fluides et dynamiques.",
    icon: "./images/nodejs.png",
  },
  {
    id: 3,
    name: "React",
    description:
      "En tant qu'adepte de React, je conçois des interfaces utilisateur réactives et modulaires. Les composants React sont ma toile, où je fusionne le développement et le design pour créer des applications web modernes et intuitives.",
    icon: "./images/react.png",
  },
  {
    id: 10,
    name: "Sass",
    description:
      "Avec Sass, j'ajoute une couche de puissance au CSS en utilisant des variables et des fonctions. J'optimise la gestion des styles pour garantir des interfaces harmonieuses et réutilisables.",
    icon: "./images/sass.png",
  },

  {
    id: 5,
    name: "MongoDB",
    description:
      "Avec MongoDB, je navigue dans le monde des bases de données NoSQL. Je crée des structures de données flexibles et évolutives pour soutenir des applications modernes, offrant une gestion efficace des données.",
    icon: "./images/mongo-db.png",
  },
  {
    id: 6,
    name: "MySQL",
    description:
      "En maîtrisant MySQL, je construis des bases de données relationnelles solides pour stocker et gérer les données. Je crée des solutions performantes qui garantissent une gestion efficace des informations pour les applications.",
    icon: "./images/mysql.png",
  },
  {
    id: 4,
    name: "Php",
    description:
      "En utilisant PHP, je développe des sites web dynamiques et interactifs. En collaboration avec des bases de données, je crée des applications web robustes qui fournissent des fonctionnalités personnalisées et des expériences utilisateur engageantes.",
    icon: "/images/php.png",
  },
  {
    id: 11,
    name: "Figma",
    description:
      "En utilisant Figma, je conçois des interfaces utilisateur attrayantes et fonctionnelles. Je travaille de manière collaborative, créant des maquettes et des prototypes qui donnent vie aux idées.",
    icon: "./images/figma.png",
  },
  {
    id: 12,
    name: "GitHub",
    description:
      "GitHub est ma plateforme de collaboration de prédilection. J'utilise les fonctionnalités de contrôle de version pour gérer efficacement les projets, partager du code et collaborer avec d'autres passionnés de développement.",
    icon: "./images/github-logo.png",
  },
  {
    id: 7,
    name: "Blender",
    description:
      "Avec Blender, je sculpte des mondes virtuels en 3D. De la modélisation à l'animation, je donne vie à des idées et crée des visuels saisissants pour des projets de design et de développement",
    icon: "./images/blender.png",
  },
  {
    id: 8,
    name: "DaVinci Resolve",
    description:
      "Utilisant DaVinci Resolve, je manipule et édite des vidéos avec précision. J'assemble des séquences, applique des effets et perfectionne les visuels pour produire des contenus visuels impactants.",
    icon: "./images/davinci-resolve.png",
  },
  {
    id: 9,
    name: "Adobe",
    description:
      "Je maîtrise les outils Adobe, de Photoshop à Illustrator, pour donner vie à des concepts créatifs. De la conception de logos au retouche d'images, je crée des éléments visuels qui complètent l'expérience numérique.",
    icon: "./images/adobe-creative-cloud.png",
  },
];

export default skillsData;
